import { render, staticRenderFns } from "./TreeNodeContentHeader.global.vue?vue&type=template&id=bf5c0050&lang=pug&"
import script from "./TreeNodeContentHeader.global.vue?vue&type=script&lang=ts&"
export * from "./TreeNodeContentHeader.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports